import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PlanService } from './plan.service';
import { IPlanTree } from './IPlanTree';


@Injectable()
export class PlanTreeResolve implements Resolve<IPlanTree> {
  constructor(private planService: PlanService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IPlanTree> {
    const strategyId = Number.parseInt(route.paramMap.get('strategyId'), 10);
    return this.planService.getPlanTree(strategyId);
  }
}
